var SiteConfig = {
  LOGIN_SYSTEM_NAME: "Racing Client",
  LOGIN_PHONE_LINE: 1123,
  VOID_REASON: 2,
  DEVICE_ID: "Client",
  SYSTEM_ID: "R",
  OPEN_SPOTS_ONLY: false,
  PRODUCT_TYPE: "Racing",
  ROWS: 500,
  OFF_SET: 0,
  USER_ACCESS_SVC: "useraccesssvc",
  ACCOUNT_MGMT_SVC: "accountmgmtsvc",
  RACING_SCHEDULE_SVC: "racingschedulesvc",
  RACING_TICKET_VALIDATOR_SVC: "racingticketvalidatorsvc",
  PLAYER_HISTORY_SVC: "playerhistorysvc",
  WAGER_POST_SVC: "wagerpostsvc",
};

export default SiteConfig;
